import { render } from "./PdfViewer.vue?vue&type=template&id=9dbc0c56"
import script from "./PdfViewer.vue?vue&type=script&lang=js"
export * from "./PdfViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__